import Contact from '../components/Contact/Contact'
export default function ContactPage() {
    return(
        <main className=' mt-28'>
            <Contact />
        </main>
    )
}